import { Component } from '@angular/core';

@Component({
  selector: 'app-cart',
  standalone: false,

  templateUrl: './cart.component.html',
  styleUrl: './cart.component.scss'
})
export class CartComponent {
  cartItems = [
    { name: 'Producto A', price: 100, qty: 1 },
    { name: 'Producto B', price: 200, qty: 2 }
  ];

  get total(): number {
    return this.cartItems.reduce((acc, item) => acc + item.price * item.qty, 0);
  }
}